<div
  class="divide-s300 mt-1 flex select-none flex-col divide-y pr-5"
  *ngIf="!!mconfig"
>
  <div
    *ngFor="let filter of parametersFilters; let filterIndex = index"
    class="flex flex-row items-start justify-start"
    [ngClass]="{
      'pt-6': filterIndex !== 0
    }"
  >
    <div class="flex flex-row items-start justify-center">
      <div
        tp="A required filter cannot be removed"
        [tpIsEnabled]="filter.field.required === true"
      >
        <button
          class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
          [ngClass]="{
            'hover:bg-m200 text-s500': filter.field.required !== true,
            'text-s400 cursor-default': filter.field.required === true
          }"
          [disabled]="filter.field.required === true"
          (click)="deleteFilter(filter)"
        >
          <m-trash-icon></m-trash-icon>
        </button>
      </div>

      <div
        class="mb-5 ml-5 flex flex-shrink-0 flex-col items-start justify-start"
      >
        <div class="truncate text-sm font-normal">{{
          filter.field.topLabel | capitalize
        }}</div>

        <div class="flex flex-row text-left font-semibold">
          <div *ngIf="filter.field.groupLabel"
            >{{ filter.field.groupLabel | capitalize }} -
            {{ filter.field.label | capitalize }}</div
          >

          <div *ngIf="!filter.field.groupLabel">{{
            filter.field.label | capitalize
          }}</div>
        </div>
      </div>

      <div
        *ngIf="!!filter.listen"
        class="ml-5 mt-2"
        tp="To edit listeners use Listeners button in table header"
      >
        <m-link-icon class="text-s500"></m-link-icon>
      </div>
    </div>

    <div class="flex w-full flex-col">
      <div
        *ngIf="!!filter.listen"
        class="mb-6 ml-5 mt-2 flex w-[300px] flex-row"
      >
        {{ filter.listen }}
      </div>

      <div *ngIf="!filter.listen">
        <div
          class="flex flex-row items-start justify-start"
          *ngFor="
            let fraction of filter.fractions;
            let isFirst = first;
            let fractionIndex = index
          "
        >
          <m-fraction
            [suggestModelDimension]="filter.field.suggestModelDimension"
            [structId]="mconfig.structId"
            [reportId]="report.reportId"
            [rowId]="reportSelectedNode?.data?.rowId"
            [fieldResult]="filter.field.result"
            [fieldTimeframe]="filter.field.timeframe"
            [storeContent]="getStoreContent()"
            [isMetricsPage]="true"
            [fraction]="fraction"
            [fractionIndex]="fractionIndex"
            [isFirst]="isFirst"
            (fractionUpdate)="fractionUpdate(filter, $event)"
          >
          </m-fraction>

          <div
            tp="Filter max_fractions reached"
            [tpIsEnabled]="
              !!filter.field.maxFractions &&
              filter.field.maxFractions === filter.fractions.length
            "
          >
            <button
              class="ml-3 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
              (click)="addFraction(filter)"
              [ngClass]="{
                'hover:bg-m200 text-s500':
                  !filter.field.maxFractions ||
                  filter.field.maxFractions !== filter.fractions.length,
                'text-s400 cursor-default':
                  !!filter.field.maxFractions &&
                  filter.field.maxFractions === filter.fractions.length
              }"
              [disabled]="
                !!filter.field.maxFractions &&
                filter.field.maxFractions === filter.fractions.length
              "
            >
              <m-add-icon></m-add-icon>
            </button>
          </div>

          <div
            tp="A required filter cannot be removed"
            [tpIsEnabled]="
              filter.field.required === true && filter.fractions.length === 1
            "
          >
            <button
              class="hover:bg-m200 ml-3 flex h-9 w-9 items-center justify-center rounded focus:outline-none"
              (click)="deleteFraction(filter, fractionIndex)"
              [ngClass]="{
                'hover:bg-m200 text-s500':
                  filter.field.required !== true ||
                  filter.fractions.length !== 1,
                'text-s400 cursor-default':
                  filter.field.required === true &&
                  filter.fractions.length === 1
              }"
              [disabled]="
                filter.field.required === true && filter.fractions.length === 1
              "
            >
              <m-trash-icon></m-trash-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div *ngIf="uiQuery$ | async"></div> -->
